import { OP_SEARCH_ITEMS } from '@doda/common/src/constants/searchItems';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { RequirementListType } from 'types/kodawari';
import { REQUIREMENT_CODE_AND_QUERY } from 'constants/searchCondition';
import { HooksArgument } from 'components/SearchSideBar/types';
import { getInitialIdList } from '../getInitialIdList';

/**
 * 募集・採用情報の初期状態を生成
 * @param param.savedSearchCondition 保存した検索条件のレスポンス
 * @param param.featuredSearchCondition 特集枠検索条件のレスポンス
 * @param param.queries クエリパラメータ
 * @param param.jobCountData 求人件数
 * @returns 募集・採用情報の初期配列
 */
export const createInitialRequirementList = ({
  savedSearchCondition,
  featuredSearchCondition,
  queries,
  jobCountData,
}: HooksArgument) => {
  const idList = getInitialIdList({
    savedSearchCondition,
    featuredSearchCondition,
    queries,
  });

  const initialData: RequirementListType[] = [
    {
      id: OP_SEARCH_ITEMS.inexperiencedOccupationWelcome.id,
      name: OP_SEARCH_ITEMS.inexperiencedOccupationWelcome.name,
      value: REQUIREMENT_CODE_AND_QUERY.INEXPERIENCED_OCCUPATION_WELCOME.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.inexperiencedOccupationWelcome.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.INEXPERIENCED_OCCUPATION_WELCOME.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.IndustryInexperiencedWelcome.id,
      name: OP_SEARCH_ITEMS.IndustryInexperiencedWelcome.name,
      value: REQUIREMENT_CODE_AND_QUERY.INDUSTRY_INEXPERIENCED_WELCOME.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.IndustryInexperiencedWelcome.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.INDUSTRY_INEXPERIENCED_WELCOME.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.noTransfer.id,
      name: OP_SEARCH_ITEMS.noTransfer.name,
      value: REQUIREMENT_CODE_AND_QUERY.NO_TRANSFER.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.noTransfer.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.NO_TRANSFER.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.noAcademicBackgroundRequired.id,
      name: OP_SEARCH_ITEMS.noAcademicBackgroundRequired.name,
      value: REQUIREMENT_CODE_AND_QUERY.NO_ACADEMIC_BACKGROUND_REQUIRED.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.noAcademicBackgroundRequired.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.NO_ACADEMIC_BACKGROUND_REQUIRED.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.secondTimeGraduate.id,
      name: OP_SEARCH_ITEMS.secondTimeGraduate.name,
      value: REQUIREMENT_CODE_AND_QUERY.SECOND_TIME_GRADUATE.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.secondTimeGraduate.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.SECOND_TIME_GRADUATE.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.expert.id,
      name: OP_SEARCH_ITEMS.expert.name,
      value: REQUIREMENT_CODE_AND_QUERY.EXPERT.code,
      isChecked: idList.some((query) => query === OP_SEARCH_ITEMS.expert.id),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.EXPERT.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.urgentRecruit.id,
      name: OP_SEARCH_ITEMS.urgentRecruit.name,
      value: REQUIREMENT_CODE_AND_QUERY.URGENT_RECRUIT.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.urgentRecruit.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.URGENT_RECRUIT.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.employsManyPeople.id,
      name: OP_SEARCH_ITEMS.employsManyPeople.name,
      value: REQUIREMENT_CODE_AND_QUERY.EMPLOYS_MANY_PEOPLE.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.employsManyPeople.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.EMPLOYS_MANY_PEOPLE.code
      ),
    },
    {
      id: OP_SEARCH_ITEMS.noChangeInJobTitle.id,
      name: OP_SEARCH_ITEMS.noChangeInJobTitle.name,
      value: REQUIREMENT_CODE_AND_QUERY.NO_CHANGE_IN_JOB_TITLE.code,
      isChecked: idList.some(
        (query) => query === OP_SEARCH_ITEMS.noChangeInJobTitle.id
      ),
      jobCount: findJobCount(
        jobCountData.requirementsList,
        REQUIREMENT_CODE_AND_QUERY.NO_CHANGE_IN_JOB_TITLE.code
      ),
    },
  ];

  return initialData;
};
